import { render, staticRenderFns } from "./mendianpk.vue?vue&type=template&id=4aa208a6&scoped=true&"
import script from "./mendianpk.vue?vue&type=script&lang=js&"
export * from "./mendianpk.vue?vue&type=script&lang=js&"
import style0 from "./mendianpk.vue?vue&type=style&index=0&id=4aa208a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa208a6",
  null
  
)

export default component.exports